import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoaderState, LOADER_FEATURE_KEY } from './ngrx-loader.reducer';

const getLoaderState = createFeatureSelector<LoaderState>(LOADER_FEATURE_KEY);

export const isLoaderVisible = createSelector(
  getLoaderState,
  (state: LoaderState) => state.active > 0
);
